<app-rc-dialog-wrapper (closePopin)="closePopin()">
  <div class="info-popin_content-wrapper">
    <h1 class="info-popin_title">{{ data?.title }}</h1>
    <div class="info-popin_content">
      <p class="text">{{ data?.description }}</p>
      @if (data?.link) {
        <div class="link">
          <rc-link
            data-qa="vs-nutritional-assessment-step-popin-link-pdf"
            variant="secondary"
            size="large"
            iconname="document-pdf"
            iconposition="left"
            target="_blank"
            rel="noopener noreferrer"
            [href]="data.link.href$ | async"
          >
            {{ data.link.text }}
          </rc-link>
        </div>
      }
    </div>
    <rc-button data-qa="vs-nutritional-assessment-step-popin-button-close" type="submit" (click)="closePopin()">
      {{ 'action_close' | translateKey }}
    </rc-button>
  </div>
</app-rc-dialog-wrapper>
